import { set, toggle } from '@/utils/vuex'

export default {
  setList: set('list'),
  setListLoading: set('listLoading'),
  set: set('record'),
  setRecordLoading: set('recordLoading'),
  totalCount: set('totalCount')
}
